module.exports = __webpack_public_path__ + "static/media/TipoDoc4.1d15cc2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadTipoDoc/TipoDoc4.png
// module id = 2194
// module chunks = 0